import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.setupClickableRows()
    this.setupCollapseIcons()
  }

  setupClickableRows() {
    // Bootstrapのcollapseイベントを利用してアイコンを切り替え
    const rows = this.element.querySelectorAll('.clickable-row')
    
    rows.forEach(row => {
      const targetId = row.dataset.bsTarget
      if (!targetId) return
      
      const collapseElement = document.querySelector(targetId)
      if (!collapseElement) return
      
      // 展開時
      collapseElement.addEventListener('show.bs.collapse', () => {
        const icon = row.querySelector('.bi-chevron-down, .bi-chevron-up')
        if (icon) {
          icon.classList.remove('bi-chevron-down')
          icon.classList.add('bi-chevron-up')
        }
        row.classList.add('table-active')
      })
      
      // 折りたたみ時
      collapseElement.addEventListener('hide.bs.collapse', () => {
        const icon = row.querySelector('.bi-chevron-down, .bi-chevron-up')
        if (icon) {
          icon.classList.remove('bi-chevron-up')
          icon.classList.add('bi-chevron-down')
        }
        row.classList.remove('table-active')
      })
    })
  }
  
  setupCollapseIcons() {
    // ボタンクリック時にイベントの伝播を停止
    const buttons = this.element.querySelectorAll('.btn-group .btn')
    buttons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.stopPropagation()
      })
    })
  }
}